var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M86.88-868.32l5.64-5.64-1.12-1.12-4.52,4.52-2.28-2.28-1.12,1.12ZM88-864a7.791,7.791,0,0,1-3.12-.63,8.08,8.08,0,0,1-2.54-1.71,8.081,8.081,0,0,1-1.71-2.54A7.79,7.79,0,0,1,80-872a7.79,7.79,0,0,1,.63-3.12,8.078,8.078,0,0,1,1.71-2.54,8.078,8.078,0,0,1,2.54-1.71A7.789,7.789,0,0,1,88-880a7.789,7.789,0,0,1,3.12.63,8.078,8.078,0,0,1,2.54,1.71,8.078,8.078,0,0,1,1.71,2.54A7.79,7.79,0,0,1,96-872a7.79,7.79,0,0,1-.63,3.12,8.081,8.081,0,0,1-1.71,2.54,8.08,8.08,0,0,1-2.54,1.71A7.791,7.791,0,0,1,88-864Z",
    transform: "translate(-80 880)",
    fill: "#3cb54c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCheck);
export default __webpack_public_path__ + "static/media/verified_check.798f3796e6c961f6a43fa951b759a70b.svg";
export { ForwardRef as ReactComponent };